import { get } from "../../service/api";

const GetSettleTransaction = async (merchantId, merchantSettleId, page = 1, size = 20, accountNumber = null) => {
    try {
        const params = new URLSearchParams({ page, size });
        if (accountNumber) params.set("accountNumber", accountNumber);
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/transaction?${params}`);
        return response;
    } catch (error) {
        console.error('Error GetSettleTransaction:', error);
        throw error;
    }
};

export default GetSettleTransaction;
